var _g, _g2, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 144,
    viewBox: "0 0 155 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.624367
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.653 0.67627C122.643 0.67627 126.694 4.3624 126.694 8.9024C126.694 13.4424 122.643 17.1285 117.653 17.1285C112.663 17.1285 108.612 13.4424 108.612 8.9024C108.612 4.3624 112.663 0.67627 117.653 0.67627Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5111 12.7593C18.5028 12.7593 21.7438 15.7082 21.7438 19.3402C21.7438 22.9722 18.5028 25.9211 14.5111 25.9211C10.5193 25.9211 7.27832 22.9722 7.27832 19.3402C7.27832 15.7082 10.5193 12.7593 14.5111 12.7593Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47199 103.656C13.4637 103.656 16.7047 106.605 16.7047 110.237C16.7047 113.869 13.4637 116.818 9.47199 116.818C5.48025 116.818 2.23926 113.869 2.23926 110.237C2.23926 106.605 5.48025 103.656 9.47199 103.656Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.258 96.6221C130.75 96.6221 133.586 99.2024 133.586 102.38C133.586 105.558 130.75 108.139 127.258 108.139C123.765 108.139 120.929 105.558 120.929 102.38C120.929 99.2024 123.765 96.6221 127.258 96.6221Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35914 76.0029C5.21305 76.0029 6.71828 77.3534 6.71828 79.0166C6.71828 80.6799 5.21305 82.0303 3.35914 82.0303C1.50523 82.0303 0 80.6799 0 79.0166C0 77.3534 1.50523 76.0029 3.35914 76.0029Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.207 51.9248C130.37 51.9248 132.126 53.5003 132.126 55.4408C132.126 57.3812 130.37 58.9567 128.207 58.9567C126.044 58.9567 124.288 57.3812 124.288 55.4408C124.288 53.5003 126.044 51.9248 128.207 51.9248Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8642 4.18457C63.8726 4.18457 65.5032 5.64754 65.5032 7.4494C65.5032 9.25125 63.8726 10.7142 61.8642 10.7142C59.8558 10.7142 58.2251 9.25125 58.2251 7.4494C58.2251 5.64754 59.8558 4.18457 61.8642 4.18457Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3427 124.76C68.6601 124.76 70.5416 126.448 70.5416 128.527C70.5416 130.606 68.6601 132.294 66.3427 132.294C64.0253 132.294 62.1438 130.606 62.1438 128.527C62.1438 126.448 64.0253 124.76 66.3427 124.76Z",
    fill: "#E2B93B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.624367
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.368 61.3218L150.109 64.5566L154.003 65.0753L151.186 67.5932L151.851 71.1486L148.368 69.47L144.885 71.1486L145.55 67.5932L142.732 65.0753L146.626 64.5566L148.368 61.3218Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77002 62.2041L10.8278 66.0263L15.4292 66.6392L12.0996 69.6144L12.8856 73.8154L8.77002 71.8319L4.65442 73.8154L5.44043 69.6144L2.11084 66.6392L6.71222 66.0263L8.77002 62.2041Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6674 4.98438L73.9884 7.43876L76.943 7.83199L74.8049 9.74211L75.3099 12.4395L72.6674 11.1657L70.025 12.4395L70.53 9.74211L68.3918 7.83199L71.3464 7.43876L72.6674 4.98438Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5503 131.583L79.6081 135.405L84.2095 136.018L80.8799 138.993L81.6659 143.194L77.5503 141.21L73.4347 143.194L74.2207 138.993L70.8911 136.018L75.4925 135.405L77.5503 131.583Z",
    fill: "#EB5757"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 22C108.595 22 131 44.405 131 72C131 99.595 108.595 122 81 122C53.405 122 31 99.595 31 72C31 44.405 53.405 22 81 22Z",
    fill: "#D7E0E2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.996765
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.917 35.626C100.785 35.626 116.917 51.7576 116.917 71.626C116.917 91.4944 100.785 107.626 80.917 107.626C61.0486 107.626 44.917 91.4944 44.917 71.626C44.917 51.7576 61.0486 35.626 80.917 35.626Z",
    fill: "#27AE60"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 69.8077L76.7977 80.0975C76.7977 80.0975 94.177 64.9396 97.5473 62",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success-img.fed11e38f4f23f649a9100dbf4a903bf.svg";
export { ForwardRef as ReactComponent };